exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root {\n  display: flex;\n  position: relative;\n}\n.root .overlapping-outline {\n  border: 1px solid #e9e9e9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.root .custom-selector-caret {\n  height: 22px;\n  margin-left: 2px;\n  margin-right: -6px;\n  width: 22px;\n}\n.root .preset-item {\n  border-left: 1px solid #e9e9e9;\n}\n.root .preset-item > * {\n  display: block;\n}\n.root .selected {\n  background-color: #f6f6f6;\n}\n.root .custom-picker-menu {\n  top: 36px;\n}\n", ""]);

// exports
